import React from 'react';
import { theme } from '../styles/theme';

const TermsOfService = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: theme.colors.background,
      color: theme.colors.text,
      fontFamily: theme.typography.fontFamily,
    },
    hero: {
      background: `linear-gradient(135deg, ${theme.colors.primary} 0%, #005a9f 100%)`,
      padding: '100px 20px',
      textAlign: 'center',
      color: 'white',
      position: 'relative',
      overflow: 'hidden',
    },
    heroPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M20 20c0 11.046-8.954 20-20 20v20h40V20H20z'/%3E%3C/g%3E%3C/svg%3E")`,
      opacity: 0.15,
    },
    heroContent: {
      position: 'relative',
      zIndex: 2,
      maxWidth: '900px',
      margin: '0 auto',
    },
    heroTitle: {
      fontSize: '4rem',
      fontWeight: '900',
      marginBottom: '24px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '3px',
      textShadow: '3px 3px 6px rgba(0,0,0,0.4)',
      lineHeight: '1.1',
    },
    heroSubtitle: {
      fontSize: '1.5rem',
      opacity: 0.95,
      maxWidth: '700px',
      margin: '0 auto 32px auto',
      lineHeight: '1.7',
      fontWeight: '400',
    },
    terminalBadge: {
      display: 'inline-block',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      border: '2px solid rgba(255,255,255,0.4)',
      padding: '12px 24px',
      borderRadius: '8px',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      fontSize: '1rem',
      fontWeight: '700',
      background: 'rgba(255,255,255,0.1)',
      backdropFilter: 'blur(10px)',
    },
    content: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '80px 20px',
    },
    effectiveDate: {
      backgroundColor: '#f8f9fa',
      padding: '24px',
      borderRadius: '12px',
      border: `3px solid ${theme.colors.primary}`,
      marginBottom: '60px',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
    },
    effectiveDatePattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23007acc' fill-opacity='0.05'%3E%3Cpath d='M0 0h20v20H0z'/%3E%3C/g%3E%3C/svg%3E")`,
    },
    effectiveDateContent: {
      position: 'relative',
      zIndex: 2,
    },
    effectiveDateText: {
      fontSize: '1.2rem',
      fontWeight: '700',
      color: theme.colors.primary,
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '1.5px',
    },
    section: {
      marginBottom: '60px',
      backgroundColor: 'white',
      borderRadius: '16px',
      padding: '50px',
      border: `3px solid ${theme.colors.primary}`,
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      position: 'relative',
      overflow: 'hidden',
    },
    sectionGlow: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `linear-gradient(45deg, transparent 0%, ${theme.colors.primary}05 50%, transparent 100%)`,
      pointerEvents: 'none',
    },
    sectionContent: {
      position: 'relative',
      zIndex: 2,
    },
    sectionTitle: {
      fontSize: '2.2rem',
      fontWeight: '900',
      color: theme.colors.primary,
      marginBottom: '32px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '2px',
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      borderBottom: `3px solid ${theme.colors.primary}`,
      paddingBottom: '16px',
    },
    sectionNumber: {
      fontSize: '1.8rem',
      fontWeight: '900',
      color: 'white',
      backgroundColor: theme.colors.primary,
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      minWidth: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '8px',
      textShadow: 'none',
    },
    subsectionTitle: {
      fontSize: '1.4rem',
      fontWeight: '700',
      color: theme.colors.text,
      marginTop: '40px',
      marginBottom: '20px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '1px',
      position: 'relative',
      paddingLeft: '25px',
    },
    subsectionBracket: {
      position: 'absolute',
      left: '0',
      top: '0',
      color: theme.colors.primary,
      fontWeight: '900',
      fontSize: '1.6rem',
    },
    paragraph: {
      marginBottom: '24px',
      fontSize: '1.1rem',
      lineHeight: '1.8',
      color: theme.colors.textLight,
    },
    strongText: {
      fontWeight: '700',
      color: theme.colors.text,
    },
    list: {
      paddingLeft: '0',
      marginBottom: '32px',
      listStyle: 'none',
    },
    listItem: {
      marginBottom: '16px',
      fontSize: '1.1rem',
      lineHeight: '1.7',
      color: theme.colors.textLight,
      paddingLeft: '35px',
      position: 'relative',
    },
    listBullet: {
      position: 'absolute',
      left: '0',
      top: '0',
      color: theme.colors.primary,
      fontWeight: '900',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      fontSize: '1.2rem',
    },
    highlight: {
      backgroundColor: `${theme.colors.primary}15`,
      padding: '32px',
      borderRadius: '12px',
      marginBottom: '40px',
      border: `3px solid ${theme.colors.primary}`,
      position: 'relative',
      overflow: 'hidden',
    },
    highlightPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23007acc' fill-opacity='0.1'%3E%3Cpath d='M15 0v30M0 15h30'/%3E%3C/g%3E%3C/svg%3E")`,
    },
    highlightContent: {
      position: 'relative',
      zIndex: 2,
    },
    warningBox: {
      backgroundColor: '#fff3cd',
      border: '3px solid #ffc107',
      padding: '24px',
      borderRadius: '12px',
      marginBottom: '32px',
      position: 'relative',
      overflow: 'hidden',
    },
    warningPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 25 25' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffc107' fill-opacity='0.1'%3E%3Cpath d='M12.5 0l12.5 25H0z'/%3E%3C/g%3E%3C/svg%3E")`,
    },
    warningContent: {
      position: 'relative',
      zIndex: 2,
      color: '#856404',
    },
    contact: {
      background: `linear-gradient(135deg, ${theme.colors.primary} 0%, #005a9f 100%)`,
      color: 'white',
      padding: '60px',
      borderRadius: '16px',
      textAlign: 'center',
      marginTop: '80px',
      position: 'relative',
      overflow: 'hidden',
    },
    contactPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M25 25c0 13.807-11.193 25-25 25v25h50V25H25z'/%3E%3C/g%3E%3C/svg%3E")`,
    },
    contactContent: {
      position: 'relative',
      zIndex: 2,
    },
    contactTitle: {
      fontSize: '2.5rem',
      fontWeight: '900',
      marginBottom: '24px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      textTransform: 'uppercase',
      letterSpacing: '2px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
    },
    contactInfo: {
      fontSize: '1.3rem',
      marginBottom: '16px',
      fontFamily: "'Courier New', 'Monaco', 'Menlo', monospace",
      letterSpacing: '1px',
    },
    contactEmail: {
      color: 'white',
      textDecoration: 'none',
      fontWeight: '700',
      border: '2px solid rgba(255,255,255,0.3)',
      padding: '12px 24px',
      borderRadius: '8px',
      display: 'inline-block',
      marginTop: '16px',
      transition: 'all 0.3s ease',
      backgroundColor: 'rgba(255,255,255,0.1)',
      backdropFilter: 'blur(10px)',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    // Responsive styles
    '@media (max-width: 768px)': {
      heroTitle: {
        fontSize: '2.5rem',
      },
      section: {
        padding: '30px',
        marginBottom: '40px',
      },
      sectionTitle: {
        fontSize: '1.8rem',
      },
      content: {
        padding: '40px 15px',
      },
    },
  };

  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div style={styles.container}>
      {/* Enhanced Hero Section */}
      <div style={styles.hero}>
        <div style={styles.heroPattern}></div>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>[TERMS_OF_SERVICE]</h1>
          <p style={styles.heroSubtitle}>
            These comprehensive terms govern your use of ByteBot's AI chatbot platform. 
            By using our services, you agree to these legally binding terms and conditions 
            designed to protect both your business and ours.
          </p>
          <div style={styles.terminalBadge}>
            [LAST_UPDATED: {currentDate}]
          </div>
        </div>
      </div>

      <div style={styles.content}>
        {/* Enhanced Effective Date */}
        <div style={styles.effectiveDate}>
          <div style={styles.effectiveDatePattern}></div>
          <div style={styles.effectiveDateContent}>
            <div style={styles.effectiveDateText}>
              [EFFECTIVE_DATE: {currentDate} | VERSION_3.0]
            </div>
          </div>
        </div>

        {/* Agreement to Terms */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>01</span>
              [AGREEMENT_TO_TERMS]
            </h2>
            <div style={styles.highlight}>
              <div style={styles.highlightPattern}></div>
              <div style={styles.highlightContent}>
                <p><span style={styles.strongText}>[LEGAL_BINDING_AGREEMENT]</span> - These Terms of Service constitute a legally binding agreement between you and ByteBot regarding your use of our AI chatbot platform and related services.</p>
              </div>
            </div>
            <p style={styles.paragraph}>
              By accessing, using, or creating an account on ByteBot's platform, you acknowledge that you have read, 
              understood, and agree to be bound by these Terms of Service and our Privacy Policy. 
              These terms apply to all users, customers, visitors, and others who access or use the service.
            </p>
            <p style={styles.paragraph}>
              <span style={styles.strongText}>Eligibility Requirements:</span> You must be at least 18 years old and have the legal capacity 
              to enter into binding contracts. If you are using ByteBot on behalf of a business or organization, 
              you represent and warrant that you have the authority to bind that entity to these terms.
            </p>
            <p style={styles.paragraph}>
              <span style={styles.strongText}>Geographic Scope:</span> These services are offered and available to users who are located in the United States. 
              By using this service, you represent and warrant that you are located in the United States or its territories.
            </p>
          </div>
        </div>

        {/* Service Description */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>02</span>
              [SERVICE_DESCRIPTION]
            </h2>
            
            <p style={styles.paragraph}>
              ByteBot is an AI-powered chatbot platform designed for businesses to create, customize, deploy, 
              and manage intelligent conversational interfaces for customer service and engagement.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>CORE_FEATURES]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>ByteBot Builder:</span> Conversational AI assistant that helps you create custom chatbots through natural dialogue, eliminating technical complexity
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Knowledge Base Management:</span> Tools to upload, organize, and manage business information, FAQs, policies, and training content for your chatbots
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Embeddable Chat Widgets:</span> Customizable chat interfaces that can be embedded on your website with flexible styling and positioning options
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Conversation Analytics:</span> Detailed insights, performance metrics, and analytics to help you understand and improve customer interactions
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Multi-Agent Management:</span> Create and manage multiple chatbots for different purposes, departments, or business units
              </li>
            </ul>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>SERVICE_LEVELS]
            </h3>
            <p style={styles.paragraph}>
              ByteBot offers multiple service tiers with different conversation limits, features, and support levels. 
              Current pricing and plan details are available on our pricing page and may be updated from time to time. 
              Service limitations and usage quotas apply based on your selected plan.
            </p>
          </div>
        </div>

        {/* User Accounts and Security */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>03</span>
              [ACCOUNTS_SECURITY]
            </h2>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>ACCOUNT_CREATION]
            </h3>
            <p style={styles.paragraph}>
              To use ByteBot, you must create an account by providing accurate, current, and complete information. 
              You are responsible for maintaining the confidentiality of your account credentials and for all activities 
              that occur under your account.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>SECURITY_RESPONSIBILITIES]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Password Security:</span> Maintain strong, unique passwords and enable two-factor authentication when available
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Unauthorized Access:</span> Immediately notify us of any unauthorized use of your account or security breaches
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Account Information:</span> Keep your account information accurate and up-to-date
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Shared Access:</span> You are responsible for all users who access ByteBot through your account
              </li>
            </ul>
          </div>
        </div>

        {/* Acceptable Use Policy */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>04</span>
              [ACCEPTABLE_USE]
            </h2>
            
            <div style={styles.warningBox}>
              <div style={styles.warningPattern}></div>
              <div style={styles.warningContent}>
                <p><span style={styles.strongText}>[PROHIBITED_ACTIVITIES]</span> - You agree not to use ByteBot for any unlawful, harmful, or prohibited purposes. Violations may result in immediate account suspension or termination.</p>
              </div>
            </div>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>PROHIBITED_CONTENT]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Illegal Activities:</span> Any content or activities that violate local, state, federal, or international laws
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Harmful Content:</span> Harassment, abuse, discrimination, hate speech, or content that promotes violence
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Fraudulent Activities:</span> Deceptive practices, scams, phishing, or any form of financial fraud
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Intellectual Property Violations:</span> Infringing on copyrights, trademarks, or other intellectual property rights
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Adult Content:</span> Sexually explicit material, pornography, or content inappropriate for general audiences
              </li>
            </ul>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>PROHIBITED_ACTIVITIES]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>System Abuse:</span> Attempting to breach security, access unauthorized data, or disrupt service operations
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Automated Abuse:</span> Using bots, scrapers, or automated tools to access the service inappropriately
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Reverse Engineering:</span> Attempting to reverse engineer, decompile, or extract source code from our platform
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Resource Abuse:</span> Excessive usage that disrupts service for other users or violates fair use principles
              </li>
            </ul>
          </div>
        </div>

        {/* Data and Privacy Responsibilities */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>05</span>
              [DATA_PRIVACY]
            </h2>
            
            <p style={styles.paragraph}>
              Your privacy and data security are fundamental to our service. Please review our Privacy Policy 
              for detailed information about how we collect, use, and protect your data and your customers' data.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>YOUR_RESPONSIBILITIES]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Customer Consent:</span> Ensure you have proper legal basis and consent for collecting and processing customer data through your chatbots
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Privacy Compliance:</span> Comply with applicable privacy laws including GDPR, CCPA, PIPEDA, and other relevant regulations
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Data Accuracy:</span> Ensure accuracy and appropriateness of information provided to your customers through chatbots
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Privacy Notices:</span> Provide clear privacy notices to your customers about data collection and use through your chatbots
              </li>
            </ul>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>DATA_OWNERSHIP]
            </h3>
            <p style={styles.paragraph}>
              You retain ownership of all data you input into ByteBot, including knowledge base content, 
              conversation data, and customer information. ByteBot serves as a data processor for your customer data 
              and maintains appropriate technical and organizational measures to protect this information.
            </p>
          </div>
        </div>

        {/* Payment Terms */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>06</span>
              [PAYMENT_TERMS]
            </h2>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>BILLING_STRUCTURE]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Payment Processing:</span> All payments are processed securely through Stripe, our payment processor
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Billing Cycle:</span> Subscriptions are billed monthly or annually in advance based on your selected plan
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Auto-Renewal:</span> Paid subscriptions automatically renew unless cancelled before the renewal date
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Usage Limits:</span> Plans include specific conversation limits and feature restrictions as outlined in your plan details
              </li>
            </ul>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>REFUNDS_CANCELLATIONS]
            </h3>
            <p style={styles.paragraph}>
              You may cancel your subscription at any time through your account dashboard. 
              Cancellations take effect at the end of the current billing period. 
              We do not provide prorated refunds for partial periods, except as required by applicable law 
              or in cases of significant service failures on our part.
            </p>

            <p style={styles.paragraph}>
              <span style={styles.strongText}>Failed Payments:</span> If payment fails, we will attempt to retry the payment. 
              Continued payment failures may result in account suspension or termination. 
              You are responsible for keeping payment information current and valid.
            </p>
          </div>
        </div>

        {/* Intellectual Property */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>07</span>
              [INTELLECTUAL_PROPERTY]
            </h2>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>BYTEBOT_OWNERSHIP]
            </h3>
            <p style={styles.paragraph}>
              ByteBot and all associated intellectual property, including but not limited to software, 
              technology, trademarks, logos, and proprietary methods, are owned by ByteBot and protected by 
              United States and international copyright, trademark, and other intellectual property laws.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>USER_CONTENT_RIGHTS]
            </h3>
            <p style={styles.paragraph}>
              You retain all rights to content you create, upload, or input into ByteBot, including 
              knowledge base content, chatbot configurations, and training materials. 
              By using our service, you grant ByteBot a limited, non-exclusive license to use this content 
              solely for the purpose of providing and improving our services to you.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>USAGE_LICENSE]
            </h3>
            <p style={styles.paragraph}>
              Subject to these Terms, ByteBot grants you a limited, non-exclusive, non-transferable license 
              to access and use our services for your business purposes. This license does not include 
              any right to redistribute, modify, or create derivative works from our platform.
            </p>
          </div>
        </div>

        {/* Service Availability and Support */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>08</span>
              [SERVICE_AVAILABILITY]
            </h2>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>UPTIME_COMMITMENT]
            </h3>
            <p style={styles.paragraph}>
              We strive to maintain high service availability and reliability. However, ByteBot is provided "as is" 
              and we do not guarantee uninterrupted service. Planned maintenance, updates, and occasional 
              technical issues may result in temporary service interruptions.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>SUPPORT_SERVICES]
            </h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Email Support:</span> All plans include email support with response times varying by plan level
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Documentation:</span> Comprehensive guides, tutorials, and API documentation when available online
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Priority Support:</span> Higher-tier plans include priority support with faster response times
              </li>
            </ul>
          </div>
        </div>

        {/* Limitation of Liability */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>09</span>
              [LIABILITY_LIMITATIONS]
            </h2>
            
            <div style={styles.highlight}>
              <div style={styles.highlightPattern}></div>
              <div style={styles.highlightContent}>
                <p><span style={styles.strongText}>[AS_IS_SERVICE]</span> - ByteBot is provided "as is" and "as available" without warranties of any kind, either express or implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement.</p>
              </div>
            </div>

            <p style={styles.paragraph}>
              To the maximum extent permitted by applicable law, ByteBot shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages, including but not limited to loss of profits, 
              data, revenue, business opportunities, or other economic loss, arising out of or in connection with 
              your use of our services.
            </p>

            <p style={styles.paragraph}>
              <span style={styles.strongText}>Maximum Liability:</span> Our total liability to you for all claims arising out of or 
              relating to these Terms or the use of our services shall not exceed the amount you paid to ByteBot 
              in the twelve (12) months preceding the claim, or $100, whichever is greater.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>AI_LIMITATIONS]
            </h3>
            <p style={styles.paragraph}>
              ByteBot uses artificial intelligence technology which may occasionally produce inaccurate, 
              inappropriate, or unexpected responses. You are responsible for monitoring and controlling 
              the content generated by your chatbots. We are not liable for any consequences resulting 
              from AI-generated content or responses.
            </p>
          </div>
        </div>

        {/* Termination */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>10</span>
              [TERMINATION]
            </h2>
            
            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>USER_TERMINATION]
            </h3>
            <p style={styles.paragraph}>
              You may terminate your account at any time by canceling your subscription through your account dashboard 
              or by contacting our support team. Upon termination, your access to ByteBot will cease immediately, 
              but your data will be retained for 30 days to allow for data recovery if needed.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>BYTEBOT_TERMINATION]
            </h3>
            <p style={styles.paragraph}>
              We may suspend or terminate your account immediately, without prior notice, if you violate these Terms, 
              engage in prohibited activities, fail to pay fees when due, or if we reasonably believe 
              your account poses a security risk to our platform or other users.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>DATA_RETENTION]
            </h3>
            <p style={styles.paragraph}>
              Upon account termination, we will retain your data for 30 days to allow for account recovery or data export. 
              After this period, all account data, including chatbot configurations, conversation logs, 
              and knowledge base content, will be permanently deleted from our systems, 
              except as required for legal compliance or dispute resolution.
            </p>
          </div>
        </div>

        {/* Indemnification */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>11</span>
              [INDEMNIFICATION]
            </h2>

            <p style={styles.paragraph}>
              You agree to indemnify, defend, and hold harmless ByteBot, its officers, directors, employees, 
              agents, and affiliates from and against any claims, damages, obligations, losses, liabilities, 
              costs, or debt, and expenses (including attorney's fees) arising from:
            </p>

            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                Your use of ByteBot services or violation of these Terms
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                Content you upload, create, or transmit through our platform
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                Your violation of any rights of another party
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                Your violation of any applicable laws or regulations
              </li>
            </ul>
          </div>
        </div>

        {/* Governing Law and Dispute Resolution */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>12</span>
              [GOVERNING_LAW]
            </h2>

            <p style={styles.paragraph}>
              These Terms shall be governed by and construed in accordance with the laws of the United States 
              and the State of Delaware, without regard to conflict of law principles. 
              Any legal action or proceeding arising under these Terms will be brought exclusively 
              in the federal or state courts located in Delaware.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>DISPUTE_RESOLUTION]
            </h3>
            <p style={styles.paragraph}>
              Before initiating formal legal proceedings, both parties agree to attempt to resolve disputes 
              through good faith negotiation. If a dispute cannot be resolved through negotiation within 60 days, 
              either party may pursue resolution through binding arbitration under the rules of the American Arbitration Association.
            </p>
          </div>
        </div>

        {/* Changes to Terms */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>13</span>
              [TERMS_UPDATES]
            </h2>

            <p style={styles.paragraph}>
              We may update these Terms of Service periodically to reflect changes in our services, 
              legal requirements, or business practices. We will notify you of significant changes through:
            </p>

            <ul style={styles.list}>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Email Notification:</span> Direct notice to your registered email address for material changes
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Platform Notice:</span> In-app notifications and dashboard alerts
              </li>
              <li style={styles.listItem}>
                <span style={styles.listBullet}>&gt;</span>
                <span style={styles.strongText}>Website Banner:</span> Prominent notice on our website
              </li>
            </ul>

            <p style={styles.paragraph}>
              Your continued use of ByteBot after the effective date of updated Terms constitutes 
              acceptance of the new terms. If you do not agree to updated Terms, 
              you must stop using our services and may terminate your account.
            </p>
          </div>
        </div>

        {/* Miscellaneous */}
        <div style={styles.section}>
          <div style={styles.sectionGlow}></div>
          <div style={styles.sectionContent}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionNumber}>14</span>
              [MISCELLANEOUS]
            </h2>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>SEVERABILITY]
            </h3>
            <p style={styles.paragraph}>
              If any provision of these Terms is held to be invalid or unenforceable, 
              the remaining provisions will remain in full force and effect.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>ENTIRE_AGREEMENT]
            </h3>
            <p style={styles.paragraph}>
              These Terms, together with our Privacy Policy, constitute the entire agreement between you and ByteBot 
              regarding the use of our services and supersede all prior agreements and understandings.
            </p>

            <h3 style={styles.subsectionTitle}>
              <span style={styles.subsectionBracket}>[</span>FORCE_MAJEURE]
            </h3>
            <p style={styles.paragraph}>
              ByteBot shall not be liable for any delay or failure to perform resulting from causes 
              outside our reasonable control, including but not limited to acts of God, natural disasters, 
              war, terrorism, government actions, or internet service provider failures.
            </p>
          </div>
        </div>

        {/* Enhanced Contact Section */}
        <div style={styles.contact}>
          <div style={styles.contactPattern}></div>
          <div style={styles.contactContent}>
            <h2 style={styles.contactTitle}>[LEGAL_SUPPORT]</h2>
            <p style={styles.contactInfo}>
              Questions about these Terms of Service?
            </p>
            <p style={styles.contactInfo}>
              Our team is here to help clarify any provisions.
            </p>
            <a 
              href="/contact" 
              style={styles.contactEmail}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              [CONTACT_SUPPORT]
            </a>
            <div style={{marginTop: '32px', fontSize: '1.1rem', opacity: '0.9'}}>
              <div>Response Time: Within 5 business days</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 